import React from 'react';
import { Inspector } from '@bynder/design-system';
import ShotItem from 'packages/pages/design/sidebar/shots/ShotItem';
import { type SceneRow } from './utils';
import DynamicElementSelectionRow from './DynamicElementSelectionRow';

type Props = {
    rows: SceneRow[];
    isToolbarDisabled: boolean;
    isLoading: boolean;
    isDisabledByReview: boolean;
};

const SceneRows = ({ rows, isToolbarDisabled, isLoading, isDisabledByReview }: Props) => {
    return rows.map((row, idx) => {
        const isLast = idx === rows.length - 1;
        const isNextDES = rows[idx + 1]?.kind === 'des-group';
        const isPrevDES = rows[idx - 1]?.kind === 'des-group';
        const shouldRenderDivider = row.kind === 'des-group' && !isLast;

        return (
            <React.Fragment key={`${row.kind}-${row.id}`}>
                {row.kind === 'element' ? (
                    <ShotItem
                        isLast={isLast || isNextDES}
                        shotElement={row.element}
                        forceRender={row.forceRender}
                        isToolbarDisabled={isToolbarDisabled}
                        isLoading={isLoading}
                        isDisabledByReview={isDisabledByReview}
                    />
                ) : (
                    <>
                        {row.depth === 0 && idx !== 0 && !isPrevDES && <Inspector.Divider />}
                        <DynamicElementSelectionRow
                            row={row}
                            isDisabled={isToolbarDisabled || isLoading || isDisabledByReview}
                        >
                            {!!row.children.length && (
                                <SceneRows
                                    rows={row.children}
                                    isToolbarDisabled={isToolbarDisabled}
                                    isLoading={isLoading}
                                    isDisabledByReview={isDisabledByReview}
                                />
                            )}
                        </DynamicElementSelectionRow>
                    </>
                )}
                {shouldRenderDivider && <Inspector.Divider />}
            </React.Fragment>
        );
    });
};

export default SceneRows;
